import { Model } from '@/models/Model';
export class Notification extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Notification';
        this.$endpoint = '/notifications';
    }
}
